export default "__VITE_ASSET__unJ$EdQE__"